import $ from 'jquery';

$(".filter").on('change', function () {
  //calling filter function each select box value change
  filter_function();
});
$(filter_function)

function filter_function() {
  const careerLevelValue = document.querySelector<HTMLSelectElement>('#filter-career-level')?.value ?? '0';
  const locationValue = document.querySelector<HTMLSelectElement>('#filter-location')?.value ?? '0';

  let visibleRows = 0;
  //traversing each row one by one
  $(".jobs tbody tr").not('.no-results').each(function () {
    const matchesCareerLevel =
      careerLevelValue === '0' ||
      $(this).find("td.careerLevel").data("career-level") === careerLevelValue;

    const matchesLocation =
      locationValue === '0' ||
      $(this).find("td.location").data("location") === locationValue;

    if (matchesCareerLevel && matchesLocation) {
      visibleRows++;
    }
    $(this).toggle(matchesCareerLevel && matchesLocation); //displaying row which satisfies all conditions
  });

  // Show some message that there have been no results
  $(".jobs tr.no-results").toggle(visibleRows === 0);
}
